export enum CityPopulationClassificationEnum {
	"UP_TO_20K" = 1,
	"20K_TO_50K" = 2,
	"50k_TO_100K" = 3,
	"OVER_100K" = 4,
}
